import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Typography, Box, Button } from '@mui/material';
import ModalForms from '../../Shared/Modals';

interface AccountDetailsModalProps {
    open: boolean;
    onClose: (data?: any, type?: string) => void;
    title?: string;
    onEdit: (account: Account) => void;
    account?: {
        email?: string;
        phone?: string;
        address?: string;
        comments?: string;
        name?: string;
    } | null;
}


const AccountDetailsModal: React.FC<AccountDetailsModalProps> = ({
    open,
    onClose,
    onEdit,
    title = '',
    account = {},
}) => {
    return (

        <ModalForms
            show={open}
            handleClose={() => onClose(null, 'cancel')}
            modalBody={<>
                <Typography variant="body1" gutterBottom>
                    <strong>Account Email: </strong> {account?.email || 'N/A'}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <strong>Account Phone: </strong> {account?.phone || 'N/A'}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <strong>Account Address: </strong> {account?.address || 'N/A'}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <strong>Comments: </strong> {account?.comments || 'N/A'}
                </Typography>
            </>}
            modalHeader={title}
            modalId={title}
            size="sm"
            modalFooter={
                <Box sx={{ display: 'flex', justifyContent: 'flex-end',gap: 2 }}>
                    <Button onClick={() => onClose(null, 'cancel')} color="primary" variant='outlined'  size='small'>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size='small'
                        onClick={() => onEdit(account!)}
                    >
                        Edit details
                    </Button>
                </Box>}
        />

        // <Dialog
        //     open={open}
        //     onClose={() => onClose(null, 'cancel')}
        //     // maxWidth="xs"  
        //     fullWidth
        // >
        //     <DialogTitle>{title}</DialogTitle>
        //     <DialogContent dividers style={{ minWidth: 140, minHeight: 127 }}>
        //         <Typography variant="body1" gutterBottom>
        //             <strong>Account Email: </strong> {account?.email || 'N/A'}
        //         </Typography>
        //         <Typography variant="body1" gutterBottom>
        //             <strong>Account Phone: </strong> {account?.phone || 'N/A'}
        //         </Typography>
        //         <Typography variant="body1" gutterBottom>
        //             <strong>Account Address: </strong> {account?.address || 'N/A'}
        //         </Typography>
        //         <Typography variant="body1" gutterBottom>
        //             <strong>Comments: </strong> {account?.comments || 'N/A'}
        //         </Typography>
        //     </DialogContent>
        //     <DialogActions>
        //         <Button onClick={() => onClose(null, 'cancel')} color="primary" variant='outlined'>
        //             Close
        //             </Button>
        //             <Button
        //                 variant="contained"
        //                 color="primary"
        //                  onClick={() => onEdit(account!)}
        //             >
        //                 Edit details
        //             </Button>
        //     </DialogActions>
        // </Dialog>
    );
};

export default AccountDetailsModal;
